<template>
  <tr>
    <td>{{ item.prsdt }}</td>
    <td>{{ item.zdeptName }}</td>
    <td>{{ item.matnr }}</td>
    <td class="al">{{ item.zzmaktx }}</td>
    <td>{{ item.prodht }}</td>
    <td>{{ item.zztotalQty }}</td>
    <td>{{ Number(item.kwmeng) }}</td>
    <td class="ar">{{ Number(item.netpr).toLocaleString() }}원</td>
    <td class="ar">{{ Number(item.netwr).toLocaleString() }}원</td>
    <td>
      <template
        v-if="
          item.dlvMthdCd == 10 || item.dlvMthdCd == 15 || item.dlvMthdCd == 25
        "
      >
        {{ item.addr }}
      </template>
      <template v-if="item.dlvMthdCd == 20">
        {{ item.dlvBranchCd }}
      </template>
      <template v-if="item.dlvMthdCd == 30">
        {{ Utils.replace(item.namePlant, "노루페인트", "") }}
      </template>
    </td>
  </tr>
</template>
<script setup>
import { defineProps, ref } from "vue";
import Utils from "@/js/utils";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
});

const item = ref(props.item);
</script>
